import { useTranslation } from 'react-i18next';

import { SessionDemo } from './SessionDemo';

/**
 * The offer and its action, beside a guided session that works (A · Série): the phone and, next to it, the same
 * moment by voice. On phones the phone comes right under the buttons and the voice under the phone.
 */
export const HomeHero = ({ onSignup, onSeePlans }) => {
  const { t } = useTranslation();
  const copy = (key) => t(`pages.Home.hero.${key}`);

  return (
    <section className="lp-hero" aria-labelledby="lp-hero-title">
      <div className="lp-wrap lp-hero__in">
        <div className="lp-hero__copy">
          <h1 id="lp-hero-title" className="lp-h1">
            {copy('title')}
          </h1>
          <p className="lp-hero__sub">{copy('sub')}</p>
          <div className="lp-hero__ctas">
            <button type="button" className="lp-btn lp-btn--big lp-btn--go" onClick={onSignup}>
              {copy('ctaPrimary')}
            </button>
            <button type="button" className="lp-btn lp-btn--big lp-btn--outline" onClick={onSeePlans}>
              {copy('ctaSecondary')}
            </button>
          </div>
          <p className="lp-hero__note">
            <b>{copy('noteFree')}</b> {copy('notePro')}
          </p>
        </div>

        <div className="lp-hero__stage" role="group" aria-label={copy('stageLabel')} aria-describedby="lp-hero-hint">
          <p id="lp-hero-hint" className="sr-only">
            {copy('stageHint')}
          </p>
          <SessionDemo />
        </div>
      </div>
    </section>
  );
};
